import React from 'react';
import PdfTextExtractor from '../../components/agentes/PdfTextExtractor';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { FaFileAlt, FaInfoCircle } from 'react-icons/fa';

function DocumentosEditor({ usuario }) {
  const ruc = usuario.ruc;
  return (
    <Container fluid className="py-4">
      <Card className="shadow-sm mb-4">
        <Card.Header className="bg-dark text-white py-3">
          <Row className="align-items-center">
            <Col>
              <h4 className="mb-0">
                <FaFileAlt className="me-2" />
                Procesador de Documentos
              </h4>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <PdfTextExtractor ruc={ruc} /> {/* Pasar el RUC como prop */}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default DocumentosEditor;